<div class="m-1">
	<button
		class="map_button"
		matTooltip="{{ options.tooltip }}"
		matTooltipClass="tooltip-map-button"
		matTooltipPosition="right"
		[class.map-button-active]="options.active"
	>
		<img class="map_button_img" [src]="options.icon" />
	</button>
</div>
